import { useState, useEffect, Fragment } from 'react'
import { ContainerStyled } from './Announcement.styled';
import { useSelector } from 'react-redux'
import { RootState } from '../../../setup';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const Announcement = () => {
    const announcements = useSelector<RootState>(({ pages }) => pages.announcements)
    const [fontSize, setFontSize] = useState(parseInt(localStorage.getItem('fontSize')) || 13)
    const [annoucement, setAnnouncement] = useState([]);
    window.addEventListener('storage', () => {
        setFontSize(parseInt(localStorage.getItem('fontSize')))
    })
    const [annoucementSettings, setAnnouncementSettings] = useState({})

    useEffect(() => {
        setAnnouncementSettings(announcements.settings)
        setAnnouncement(announcements.results)
    }, [])

    return (
        <>
            {annoucementSettings?.color && (
                <>
                    <ContainerStyled className="row align-items-center bounce" style={{ color: annoucementSettings.color, backgroundColor: annoucementSettings.background }} fontSize={fontSize}>
                        {
                            annoucement ?
                                <>
                                    <div className={`col-12 col-md-12 align-items-center`}>
                                        {/* <p>{annoucement}</p><span></span> */}
                                        {
                                            annoucement?.map((result, index) => {
                                                return (
                                                    <span key={result.id}>
                                                        {/* {result.message.length > 25 ? `${result.message.substring(0, 25)}...`  : result.message} */}
                                                        {result.message}{index !== (annoucement?.length - 1) ? <FiberManualRecordIcon className='ms-2 me-2' style={{fontSize: '7px'}}/> : null}
                                                        {result.url && (
                                                            <button key={index} style={{ borderColor: annoucementSettings?.color, color: annoucementSettings?.color }} onClick={() => window.open(result.url, '_blank')}>Show More</button>
                                                        )}
                                                    </span>
                                                )
                                            })
                                        }
                                    </div>
                                </> : null
                        }
                    </ContainerStyled>
                </>
            )}
        </>
    )
}

export default Announcement